<template>
    <b-container id="sales-order-edit" v-if="$can('view-sales-order-details') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <h3>Sales Order (#{{ displayOrderNumber }}) - Details</h3>
                    </b-col>
                    <b-col cols="1" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-wh">Location</label>
                            <b-form-select id="inline-form-select-wh" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="datasets.core.location" :options="datasets.locations" size="sm">
                            </b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-button variant="outline-primary" class="btn-sm" v-if="datasets.core.status == 'Confirmed' && ($can('view-all') || $can('view-sales-orders-receive-payment'))"
                            @click="openModal('receive-payment')">Receive Payment</b-button>
                        <b-button type="button" @click="generatePick" variant="outline-primary" class="btn-sm"
                            v-if="datasets.core.status == 'Confirmed' || datasets.core.status == 'Dispatched'"
                            :disabled="submittingPick == 1">
                            <span v-if="submittingPick">
                                <b-spinner small type="grow"></b-spinner>
                                Generating Pick Sheet...
                            </span>
                            <span v-else>Print Pick Sheet</span>
                        </b-button>
                        <b-button type="button" @click="generateInvoice('print', true, false)" variant="outline-primary"
                            class="btn-sm" v-if="datasets.core.status == 'Closed' || datasets.core.status == 'Dispatched'" :disabled="submittingInvoice == 1">
                            <span v-if="submittingInvoice">
                                <b-spinner small type="grow"></b-spinner>
                                Generating Invoice...
                            </span>
                            <span v-else>Print Invoice</span>
                        </b-button>
                        <!-- <b-button type="button" @click="generateBarcode('common')" variant="outline-primary"
                            class="btn-sm"
                            v-if="datasets.core.status == 'Dispatched' || datasets.core.status == 'Closed'"
                            :disabled="submittingBarcode == 1">
                            <span v-if="submittingBarcode">
                                <b-spinner small type="grow"></b-spinner>
                                Generating Common Barcodes...
                            </span>
                            <span v-else>Print Common Barcodes</span>
                        </b-button>

                        <b-button type="button" @click="generateBarcode('all')" variant="outline-primary" class="btn-sm"
                            v-if="datasets.core.status == 'Dispatched' || datasets.core.status == 'Closed'"
                            :disabled="submittingBarcode == 1">
                            <span v-if="submittingBarcode">
                                <b-spinner small type="grow"></b-spinner>
                                Generating All Barcodes...
                            </span>
                            <span v-else>Print All Barcodes</span>
                        </b-button> -->
                    </b-col>

                    <b-col cols="1" class="text-right">
                        <b-dropdown id="sales-order-action-menu" text="Actions" size="sm" class="mb-2 mr-sm-2 mb-sm-0">
                            <b-dropdown-item @click="generateSO('print', false)">Print Sales Order</b-dropdown-item>
                            <b-dropdown-item @click="generateSO('pdf', true)">Email Sales Order</b-dropdown-item>
                            <b-dropdown-item @click="generateSO('pdf', false)">Save Sales Order PDF</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="generateInvoice('print', false)">Print Invoice</b-dropdown-item>
                            <b-dropdown-item @click="generateInvoice('email', false, true)">Email Invoice
                            </b-dropdown-item>
                            <b-dropdown-item @click="generateInvoice('pdf')">Save Invoice PDF</b-dropdown-item>
                            <b-dropdown-item @click="replaceCustomerInfo">Replace Customer Info</b-dropdown-item>
                            <b-dropdown-item @click="splitOrderConfirm" v-if="datasets.core.status == 'Confirmed'">Split
                                Order by Vendor</b-dropdown-item>
                            <b-dropdown-item @click="openModal('apply-credit')" v-if="datasets.core.customerId">Apply Credits</b-dropdown-item>
                            <!-- <b-dropdown-item @click="removeCreditsConfirm" v-if="datasets.core.creditAmount > 0">Un-apply All Credits</b-dropdown-item> -->
                            <b-dropdown-item @click="removeCreditsConfirm">Un-apply All Credits</b-dropdown-item>
                            <b-dropdown-item @click="generateBarcode('common')">Generate Common Barcodes</b-dropdown-item>
                            <b-dropdown-item @click="generateBarcode('all')">Generate All Barcodes</b-dropdown-item>
                            <b-dropdown-item @click="openModal('charge-credit-card')" v-if="(datasets.core.status == 'Closed' || datasets.core.status == 'Dispatched') && ($can('view-payment-charge-credit-card') || $can('view-all'))">Charge Credit Card</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="openModal('show-customer-card')" v-if="$can('view-customer-detail-payment-method-full-card') || $can('view-all')">View Credit Cards</b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-status">Status</label>
                            <b-form-select id="inline-form-select-status" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="datasets.core.status" :options="datasets.statuses" size="sm"></b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="2" class="text-right" v-if="$can('view-sales-orders-details-branding') || $can('view-all')">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-branding">Company</label>
                            <b-form-select id="inline-form-select-branding" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="datasets.core.company_branding_id" :options="companyBrandingOptions" size="sm">
                            </b-form-select>
                        </b-form>
                    </b-col>
                    <b-col :cols="($can('view-sales-orders-details-branding') || $can('view-all')) ? 1 : 3" class="text-right">
                        <b-button type="submit" variant="success" @click="saveConfirm" class="btn-sm"
                            :disabled="!datasets.core.customer || submitting">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Saving...
                            </span>
                            <span v-else>Save</span>
                        </b-button>
                    </b-col>
                </b-row>
                <hr />
            </b-container>
        </b-row>
        <b-row :key="pageKey">
            <b-col cols="7">
                <b-form-row>
                    <b-col>
                        <b-form-group id="select-group-source" label="Source:" label-for="select-source"
                            label-size="sm">
                            <b-form-select v-model="datasets.core.source" :options="datasets.sources" size="sm">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="datepicker-group-date-received" label="Date Received:"
                            label-for="datepicker-date-received" label-size="sm">
                            <b-form-datepicker id="datepicker-date-received" v-model="datasets.core.date" class="mb-2"
                                size="sm" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                locale="en">
                            </b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="datepicker-group-date-shipped" label="Date Shipped:"
                            label-for="datepicker-date-shipped" label-size="sm">
                            <b-form-datepicker id="datepicker-date-shipped" v-model="datasets.core.dateShipped"
                                class="mb-2" size="sm"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                locale="en">
                            </b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-customer" label="Customer:" label-for="input-customer"
                            label-size="sm">
                            <div class="options-assign">
                                <div class="autosuggest-container">
                                    <vue-autosuggest v-model="datasets.core.customer"
                                        :suggestions="autosuggest.customer.suggestions" @click="clickHandlerCustomer"
                                        @input="fetchResultsCustomer" @selected="onSelectedCustomer"
                                        @keydown.tab="suggestFirstCustomer($event.target.value)"
                                        :get-suggestion-value="getSuggestionValueCustomer"
                                        :input-props="{id:'autosuggest__input', placeholder:''}"
                                        @keyup.enter="suggestFirstCustomer($event.target.value)"
                                        @change="customerChanged(0)">

                                        <b-container slot-scope="{suggestion}" fluid>
                                            <b-row>
                                                <b-col class="text-right">
                                                    {{ suggestion.item.name }} ({{suggestion.item.id}})
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </vue-autosuggest>
                                </div>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="select-group-sales-rep" label="Sales Rep:" label-for="select-sales-rep"
                            label-size="sm">
                            <b-form-select v-model="datasets.core.salesRepId" :options="datasets.salesReps" size="sm">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group id="input-group-email" label="Email:" label-for="input-email" label-size="sm">
                            <b-form-input id="input-email" v-model="datasets.core.email" type="text" size="sm"
                                autocomplete="off" @change="customerChanged(1)">
                            </b-form-input>
                            <!-- <b-form-checkbox
                                id="checkbox-1"
                                name="checkbox-1"
                                value="accepted"
                                v-model="datasets.core.emailSend"
                                unchecked-value="not_accepted"
                                size="sm"
                            >
                                Send copy
                            </b-form-checkbox> -->
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="input-group-phone" label="Phone:" label-for="input-phone" label-size="sm">
                            <b-form-input id="input-phone" v-model="datasets.core.phone" type="text" size="sm"
                                autocomplete="off" @change="customerChanged(1)">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="input-group-fax" label="Fax:" label-for="input-fax" label-size="sm">
                            <b-form-input id="input-fax" v-model="datasets.core.fax" type="text" size="sm"
                                autocomplete="off" @change="customerChanged(1)">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col cols="2">
                        <b-form-checkbox id="checkbox-1" name="checkbox-1" value="1" v-model="datasets.core.emailSend"
                            unchecked-value="0" size="sm">
                            Send copy
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-tags" label="Summary:" label-for="input-tags" label-size="sm">
                            <vue-tags-input v-model="tags.currentTag" :tags="datasets.core.tags"
                                :autocomplete-items="filteredTags"
                                @tags-changed="newTags => datasets.core.tags = newTags" placeholder="" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-buyer" label="Buyer:" label-for="input-buyer" label-size="sm">
                            <b-form-input id="input-buyer" v-model="datasets.core.buyer" type="text" size="sm"
                                autocomplete="off" @change="customerChanged(1)">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-col>
            <b-col cols="5">
                <b-form-row>
                    <b-col>
                        <b-form-group id="select-group-sales-shipping-method" label="Shipping Method:"
                            label-for="select-shipping-method" label-size="sm">
                            <b-form-select v-model="datasets.core.shippingMethod" :options="datasets.shippingMethods"
                                size="sm" @change="customerChanged(1)"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="select-group-sales-payment-method" label="Payment Terms:"
                            label-for="select-payment-method" label-size="sm">
                            <b-form-select v-model="datasets.core.paymentTerm" :options="datasets.paymentTerms"
                                size="sm" @change="customerChanged(1)"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group id="textarea-group-billing-address" label="Billing Address:"
                            label-for="textarea-billing-address" label-size="sm">
                            <b-form-textarea id="textarea-billing-address" v-model="datasets.core.billingAddressBlock"
                                placeholder="" rows="5" size="sm" no-resize readonly
                                @dblclick.stop="openModal('edit-billing')"
                                style="cursor: pointer; background-color: #f8f9fa;"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="textarea-group-shipping-address" label="Shipping Address:"
                            label-for="textarea-shipping-address" label-size="sm">
                            <b-form-textarea id="textarea-shipping-address" v-model="datasets.core.shippingAddressBlock"
                                placeholder="" rows="5" size="sm" no-resize readonly
                                @dblclick.stop="openModal('edit-shipping')"
                                style="cursor: pointer; background-color: #f8f9fa;"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-col>
        </b-row>
        <b-row>
            <b-container fluid>
                <!-- <b-table-simple hover small responsive bordered sticky-header="430px"> -->
                <b-table-simple hover small responsive bordered>
                    <b-thead>
                        <b-tr>
                            <b-th class="text-center th-number">#</b-th>
                            <b-th></b-th>
                            <b-th>Title</b-th>
                            <b-th>SKU</b-th>
                            <b-th class="text-center">QTY Ordered</b-th>
                            <b-th v-if="datasets.core.status == 'Dispatched' || datasets.core.status == 'Closed'"
                                class="text-center">
                                QTY Shipped
                                <b-button variant="outline-secondary" size="sm" @click="populateQtyShipped" v-b-tooltip.hover title="Populate Qty Shipped">
                                    <i class="fas fa-fill-drip"></i>
                                </b-button>
                            </b-th>
                            <b-th class="text-center">Price</b-th>
                            <b-th class="text-center">% Discount <b-button variant="outline-secondary" size="sm"
                                    @click="openModal('set-discount')"><i class="fas fa-caret-down fa-xs"></i>
                                </b-button>
                            </b-th>
                            <b-th class="text-center">Total</b-th>
                            <b-th>Notes</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(item, index) in datasets.rows" :key="index" :class="`index-${index}`">
                            <td class="text-center">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                <b-img-lazy v-if="item.url" class="products-thumbs" :src="item.url"></b-img-lazy>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].description" size="sm" class="text-center"
                                    :ref="'titleinput' + index" @keyup.13="nextRow(index, 'title')"
                                    @focus="focusMeRow(index)" vf-b-tooltip.hover
                                    :title="datasets.rows[index].description" disabled></b-form-input><br />
                                <b-button size="sm" variant="outline-primary"
                                    @click="openModal('product-preview', datasets.rows[index].sku)">info</b-button>
                            </td>
                            <td>
                                <autosuggest-instance :key="index" :idx="index" @nextRow="nextRow"
                                    @suggestFirstRow="suggestFirstRow" @onSelectedRow="onSelectedRow"
                                    @focusMeRow="focusMeRow(index)" :ref="'skuinput' + index" />
                                <strong>Vendor:</strong> {{ item.vendor }}<br />
                                <strong>MPN:</strong> {{ item.mpn }}
                            </td>
                            <td>
                                <b-form-input :value="datasets.rows[index].qty" size="sm" class="text-center"
                                    @keydown="preventNonNumeric"
                                    @input="onNumericInput($event, index, 'qty'); calculateRow(index); addToDeletes(item.sku)" :ref="'qtyinput' + index"
                                    @keyup.13="nextRow(index, 'qty')" @focus="focusMeRow(index)"></b-form-input>
                                <div class="text-center">
                                    QOH: <span v-if="item.qoh">{{ item.qoh || 0 }}</span><span v-else>0</span><br />
                                    Available: <span v-if="item.available">{{ item.available || 0 }}</span><span
                                        v-else>0</span><br />
                                </div>
                            </td>
                            <td :class="{ 'highlight-red': datasets.rows[index].qtyShipped > (+datasets.rows[index].qohOriginal + +10) && (datasets.core.status == 'Closed' || datasets.core.status == 'Dispatched') && env.COMPANY_APP_QOHOVERAGE }"
                                v-if="datasets.core.status == 'Dispatched' || datasets.core.status == 'Closed'">
                                <b-form-input :value="datasets.rows[index].qtyShipped" size="sm" class="text-center"
                                    @keydown="preventNonNumeric"
                                    @input="onNumericInput($event, index, 'qtyShipped'); calculateRow(index); addToDeletes(item.sku)"
                                    :ref="'qtyShippedinput' + index" @keyup.13="nextRow(index, 'qtyShipped')"
                                    @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-if="datasets.rows[index].rateDiscounted"
                                    :value="datasets.rows[index].rateDiscounted" size="sm" class="text-center" disabled>
                                </b-form-input>
                                <b-form-input v-else :value="datasets.rows[index].rate" size="sm" class="text-center"
                                    data-price-math="1"
                                    @keydown.native="allowPriceMathKeydown"
                                    @input="onPriceMathInput($event, index, 'rate'); calculateRow(index)" :ref="'rateinput' + index"
                                    @paste.native="onPriceMathPaste($event, index, 'rate')"
                                    @blur.native="handlePriceFieldBlur($event, index, 'rate')"
                                    @keyup.13.native="handlePriceFieldEnter($event, index, 'rate', 'rate')" @focus="focusMeRow(index)"
                                    :disabled="datasets.rows[index].percentDiscount != 0"></b-form-input>
                                <div class="text-center" v-if="$can('view-product-cost') || $can('view-all')">
                                    WAC: $<span v-if="item.wac">{{ formatCurrency(item.wac) || '0.00' }}</span><span
                                        v-else>0</span><br />
                                    FIFO: $<span v-if="item.fifo">{{ formatCurrency(item.fifo) || '0.00'
                                        }}</span><span v-else>0</span><br />
                                </div>
                            </td>
                            <td>
                                <b-form-input :value="datasets.rows[index].percentDiscount" size="sm"
                                    class="text-center" @keydown="preventNonNumeric"
                                    @input="onNumericInput($event, index, 'percentDiscount'); calculateRow(index)" :ref="'percentinput' + index"
                                    @keyup.13="nextRow(index, 'percent')" @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].amount" size="sm" class="text-center"
                                    disabled></b-form-input>
                                <!-- <div class="text-center" v-if="$can('view-product-cost') || $can('view-all')">
                                    GP: $<span v-if="item.rate && item.fifo && useQtyShipped">{{
                                    formatCurrency(((item.rate - item.fifo) * item.qtyShipped)) ||
                                    '0.00'}}</span><span v-else-if="item.rate && item.fifo && !useQtyShipped">{{
                                    formatCurrency(((item.rate - item.fifo) * item.qty)) || '0.00' }}</span><span
                                        v-else>0.00</span>
                                </div> -->
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].notes" size="sm" class="text-center"
                                    :ref="'notesinput' + index" @keyup.13="nextRow(index, 'notes')"
                                    @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteRow(index)"><i
                                        class="far fa-trash-alt"></i></b-button>
                            </td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>

                <b-row>
                    <b-col cols="1">
                        <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="4">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="textarea-group-order-notes" label="Notes:"
                                    label-for="textarea-order-notes" label-size="sm">
                                    <b-form-textarea id="textarea-order-notes" v-model="datasets.core.internalNote"
                                        placeholder="" rows="8" size="sm" no-resize></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="8" class="text-right">
                        <b-table-simple hover small responsive>
                            <b-tbody>
                                <b-tr v-if="$can('view-all') || $can('view-product-cost')">
                                    <b-td></b-td>
                                    <b-td class="table-totals-col"><strong>COGS:</strong></b-td>
                                    <b-td class="table-totals-col">${{ formatCurrency(datasets.core.cogs) || '0.00'
                                        }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td class="table-totals-col"><strong>Subtotal:</strong></b-td>
                                    <b-td class="table-totals-col">${{ formatCurrency(datasets.core.subtotal) ||
                                        '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td><strong>Discount:</strong></b-td>
                                    <b-td>${{ formatCurrency(datasets.core.discounts) || '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <b-form-input v-model="datasets.core.shippingNotes" size="sm"></b-form-input>
                                    </b-td>
                                    <b-td><strong>Shipping:</strong></b-td>
                                    <b-td>
                                        <b-form-input v-model="datasets.core.shippingAmount" size="sm"
                                            class="text-right" @input="calculateTotals()"></b-form-input>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td><strong>Grand Total:</strong></b-td>
                                    <b-td>${{ formatCurrency(datasets.core.total) || '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <b-form-input v-model="datasets.core.creditNotes" size="sm"></b-form-input>
                                    </b-td>
                                    <b-td><strong>Credits:</strong></b-td>
                                    <b-td>${{ formatCurrency(datasets.core.creditAmount) || '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>
                                        <b-form-input v-model="datasets.core.paymentNotes" size="sm"></b-form-input>
                                    </b-td>
                                    <b-td><strong>Payments:</strong></b-td>
                                    <b-td>${{ formatCurrency(datasets.core.paymentAmount) || '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td><strong>Balance Due:</strong></b-td>
                                    <b-td>
                                        <span
                                            v-if="datasets.core.status == 'Closed' || datasets.core.status == 'Dispatched'">
                                            ${{ Number(datasets.core.total - datasets.core.creditAmount - datasets.core.paymentAmount).toFixed(2) }}
                                        </span>
                                        <span v-else>$0.00</span>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>

                <modal-edit-shipping v-if="modals['modal-orders-sales-orders-edit-shipping'].active"
                    :address="datasets.core.shippingAddress" @updateAddress="updateAddress" />

                <modal-edit-billing v-if="modals['modal-orders-sales-orders-edit-billing'].active"
                    :address="datasets.core.billingAddress" @updateAddress="updateAddress" />

                <modal-set-discount v-if="modals['modal-orders-sales-orders-set-discount'].active"
                    @setDiscount="setDiscount" />

                <modal-receive-payment v-if="modals['receive-payment'].active" />

                <modal-show-customer-card v-if="modals['modal-orders-sales-orders-show-customer-card'].active"
                    :customerId="datasets.core.customerId" />

                <modal-apply-credit v-if="modals['modal-orders-sales-orders-apply-credit'].active"
                    :available="datasets.core.creditAmount"
                    :customerId="datasets.core.customerId"
                    :orderTotal="datasets.core.status == 'Closed' || datasets.core.status == 'Dispatched' ? datasets.core.total - datasets.core.creditAmount - datasets.core.paymentAmount : 0"
                    :requireConfirmation="modals['modal-orders-sales-orders-apply-credit'].fromSave"
                    :rowQuantities="datasets.rows"
                    @setCredit="setCredit" />

                <modal-product-preview v-if="modals['product-preview'].active" :sku="modals['product-preview'].sku" />
                
                <modal-charge-credit-card v-if="modals['charge-credit-card'].active" 
                    :amount="datasets.core.total - datasets.core.creditAmount - datasets.core.paymentAmount"
                    :customerId="datasets.core.customers_id"
                    :orderId="datasets.core.id"
                    @paymentProcessed="onPaymentProcessed"
                    @showPaymentResult="onShowPaymentResult" />

                <!-- Payment Result Modal -->
                <b-modal 
                    id="payment-result-modal" 
                    :title="paymentResult.title" 
                    :header-bg-variant="paymentResult.variant"
                    :header-text-variant="paymentResult.variant === 'danger' ? 'white' : 'dark'"
                    :body-bg-variant="paymentResult.variant === 'danger' ? 'light' : 'white'"
                    :body-text-variant="paymentResult.variant === 'danger' ? 'dark' : 'dark'"
                    hide-footer
                    centered
                    no-close-on-backdrop
                    no-close-on-esc
                >
                    <div class="text-center">
                        <div class="mb-3">
                            <i :class="paymentResult.icon" style="font-size: 3rem;"></i>
                        </div>
                        <h5 class="mb-3">{{ paymentResult.message }}</h5>
                        <div v-if="paymentResult.details" class="mb-3">
                            <small class="text-muted">{{ paymentResult.details }}</small>
                        </div>
                    </div>
                    
                    <template v-slot:modal-footer>
                        <div class="w-100 text-center">
                            <b-button 
                                :variant="paymentResult.variant" 
                                @click="closePaymentResult"
                                size="lg"
                            >
                                {{ paymentResult.buttonText }}
                            </b-button>
                        </div>
                    </template>
                </b-modal>

            </b-container>
        </b-row>
    </b-container>
</template>

<script>
    import store from '../../../store'
    import ModalEditBilling from './modals/salesOrders/EditBilling'
    import ModalEditShipping from './modals/salesOrders/EditShipping'
    import ModalSetDiscount from './modals/salesOrders/SetDiscount'
    import ModalApplyCredit from './modals/salesOrders/ApplyCredit'
    import ModalShowCustomerCard from './modals/salesOrders/ShowCustomerCard'
    import ModalReceivePayment from '../lists/customers/modals/ReceivePayment'
    import ModalProductPreview from '../common/modals/ProductPreview'
    import ModalChargeCreditCard from '../common/modals/ChargeCreditCard'
    import { VueAutosuggest } from "vue-autosuggest"
    import AutosuggestInstance from '../../../pages/user/inventory/products/AutosuggestInstance'
    import VueTagsInput from '@johmun/vue-tags-input'
    import priceMathInput from '../../../mixins/priceMathInput'
    import { fetchActivePaymentTerms } from '../../../utils/paymentTerms'
    import { fetchActiveShippingMethods } from '../../../utils/shippingMethods'
 	export default {
    	name: 'SalesOrderDetail',

        mixins: [priceMathInput],

        metaInfo() {
            return {
                title: 'Order - #' + this.displayOrderNumber + ' - ' + this.datasets.core.customer,
            }
        },

    	components: {
            VueAutosuggest,
            AutosuggestInstance,
            VueTagsInput,
            'modal-edit-billing': ModalEditBilling,
            'modal-edit-shipping': ModalEditShipping,
            'modal-set-discount': ModalSetDiscount,
            'modal-apply-credit': ModalApplyCredit,
            'modal-receive-payment': ModalReceivePayment,
            'modal-product-preview': ModalProductPreview,
            'modal-show-customer-card': ModalShowCustomerCard,
            'modal-charge-credit-card': ModalChargeCreditCard
        },
        props: [ 'soNum' ],
        data() {
            return {
                customerReset: 0,
                customerUpdated: 0,
                customerAddressSnapshot: null,
                useQtyShipped: false,
                datasets: {
                    locations: [],
                    core: {
                        date: '',
                        shippingAddress: {},
                        billingAddress: {},
                        emailSend: 0,
                        shippingNotes: '',
                        shippingAmount: 0,
                        creditNotes: '',
                        creditAmount: 0,
                        paymentAmount: 0,
                        status: 'Open',
                        tags: [],
                        deletes: [],
                        company_branding_id: null,
                        discountsOrder: 0,
                        sales_order_number: null,
                        marketplace_order_number: null,
                        document_order_number: null
                    },
                    coreCopy: {},
                    rows: [],
                    salesReps: [],
                    companyBrandings: [],
                    shippingMethods: [],
                    paymentTerms: [],
                    statuses: [
                        'Open',
                        'Pending',
                        'Confirmed',
                        'Dispatched',
                        'Closed',
                        'Cancelled'
                    ],
                    sources: [
                        'Website',
                        'E-mail',
                        'Fax',
                        'Phone',
                        'Tradeshow',
                        'Walk In'
                    ]
                },
                tags: {
                    list: [],
                    currentTag: ''
                },
                autosuggest: {
                    customer: {
                        suggestions: [],
                        debounceMilliseconds: 1500,
                        timeout: null
                    },
                    row: {
                        suggestions: [],
                        debounceMilliseconds: 500,
                        timeout: null,
                        currentIndex: '',
                    }
                },
                modals: {
                    'modal-orders-sales-orders-edit-billing': {
                        active: 0
                    },
                    'modal-orders-sales-orders-edit-shipping': {
                        active: 0
                    },
                    'modal-orders-sales-orders-set-discount': {
                        active: 0
                    },
                    'modal-orders-sales-orders-apply-credit': {
                        active: 0,
                        fromSave: false
                    },
                    'modal-orders-sales-orders-show-customer-card': {
                        active: 0
                    },
                    'receive-payment': {
                        active: 0
                    },
                    'product-preview': {
                        active: 0
                    },
                    'charge-credit-card': {
                        active: 0
                    }
                },
                submitting: false,
                submittingPick: 0,
                submittingBarcode: 0,
                submittingInvoice: 0,
                pageKey: 1,
                paymentResult: {
                    title: '',
                    message: '',
                    details: '',
                    variant: '',
                    icon: '',
                    buttonText: '',
                    show: false
                }
            }
        },
        methods: {
            replaceCustomerInfo() {
                let allowed = ['shippingMethod', 'paymentTerm', 'email', 'phone', 'fax', 'billingAddress', 'shippingAddress', 'buyer']

                for (const [key, value] of Object.entries(this.datasets.coreCopy)) {
                    let match = allowed.some(function (el) {
                        return el === key
                    })

                    if (match) {
                        this.datasets.core[key] = value
                        this.pageKey++
                    }
                }
            },

            addToDeletes(sku) {
                this.datasets.core.deletes.push(sku)
            },

            generatePick() {
                this.submittingPick = 1
                let url = 'api/orders/sales-orders/generatepick'
                axios.post(url, {
                    soNum: this.soNum,
                    core: this.datasets.core,
                    rows: this.datasets.rows
                },
                {
                    responseType: 'blob',
                })
                .then((res) => {
                    this.forceFilePreview(res)
                    this.submittingPick = 0
                }, () => {
                    this.has_error = true
                })
            },

            generateBarcode(mode) {
                this.submittingBarcode = 1
                let url = 'api/orders/sales-orders/generatebarcode'
                axios.post(url, {
                    // soNum: this.soNum,
                    // core: this.datasets.core,
                    mode: mode,
                    rows: this.datasets.rows
                },
                    {
                        responseType: 'blob',
                    })
                    .then((res) => {
                        this.forceFilePreview(res)
                        this.submittingBarcode = 0
                    }, () => {
                        this.has_error = true
                    })
            },

            generateSO(action, email) {
                let url = 'api/orders/sales-orders/generateso'
                axios.post(url, {
                    soNum: this.soNum,
                    core: this.datasets.core,
                    rows: this.datasets.rows,
                    email: email,
                    action: action
                },
                {
                    responseType: 'blob',
                })
                .then((res) => {
                    if (email) {
                        this.showAlertBox('success', 'Email Sales Order', 'Sales Order e-mailed successfully!')
                    } else if (action == 'print') {
                        this.forceFilePreview(res)
                    } else if (action == 'pdf') {
                        this.forceFileDownload(res, 'sales_order_' + this.displayOrderNumber + '_')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            generateInvoice(action, staticButton, email) {
                if (staticButton) { this.submittingInvoice = 1 }

                let url = 'api/orders/sales-orders/generateinvoice'
                axios.post(url, {
                    soNum: this.soNum,
                    core: this.datasets.core,
                    rows: this.datasets.rows,
                    email: email,
                    action: action
                },
                {
                    responseType: 'blob',
                })
                .then((res) => {
                    if (email) {
                        this.showAlertBox('success', 'Email Invoice', 'Invoice e-mailed successfully!')
                    } else if (action == 'print') {
                        this.forceFilePreview(res)

                        if (staticButton) { this.submittingInvoice = 0 }
                    } else if (action == 'pdf') {
                        this.forceFileDownload(res, 'sales_order_' + this.displayOrderNumber + '_')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            forceFilePreview(response){
                // var file = new Blob([response.data], {type: 'text/html'});
                var file = new Blob([response.data], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            },

            forceFileDownload(response, fileName){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName + +new Date() + '.pdf') //or any other extension
                document.body.appendChild(link)
                link.click()
            },

            saveConfirm() {
                var balance = this.datasets.core.total - +this.datasets.core.creditAmount - +this.datasets.core.paymentAmount
                let status = this.datasets.core.status
                var availablePaymentAmount = Number(0)
                var availableCreditAmount = Number(0)

                if (balance > 0 && (status == 'Closed' || status == 'Confirmed' || status == 'Dispatched')) {
                    // get available payments
                    let paymentsUrl = 'api/accounting/payments/getavailable/' + this.datasets.core.customerId
                    axios.get(paymentsUrl, {})
                        .then((res) => {
                            let availablePayments = balance <= res.data.available ? balance : res.data.available
                            availablePaymentAmount = availablePayments

                            // get available credits (including overpayments)
                            let creditsUrl = 'api/orders/creditmemos/getavailablecredits/' + this.datasets.core.customerId
                            axios.get(creditsUrl, {})
                                .then((res) => {
                                    let availableCredits = balance <= res.data.totalAvailable ? balance : res.data.totalAvailable
                                    availableCreditAmount = availableCredits

                                    // show payment/credit popup with tabs
                                    if (
                                            (
                                                (availableCreditAmount && (!this.datasets.core.appliedCredit || parseFloat(this.datasets.core.appliedCredit) == 0)) ||
                                                (availablePaymentAmount && parseFloat(this.datasets.core.paymentAmount) == 0)
                                            ) &&
                                            (
                                                !this.datasets.core.payments_ignored || !this.datasets.core.credits_ignored
                                            )
                                        )
                                    {
                                        this.$bvModal.msgBoxConfirm('Payments/Credits available. Would you like to apply?', {
                                            title: 'Apply Payments/Credits',
                                            size: 'sm',
                                            buttonSize: 'sm',
                                            okVariant: 'success',
                                            okTitle: 'Yes',
                                            cancelTitle: 'No',
                                            footerClass: 'p-2',
                                            hideHeaderClose: false,
                                            centered: true
                                        })
                                            .then(value => {
                                                if (value) {
                                                    // Always use new ApplyCredit modal for credits
                                                    if (availableCreditAmount && (!this.datasets.core.appliedCredit || parseFloat(this.datasets.core.appliedCredit) == 0)) {
                                                        this.submitting = true
                                                        this.openModal('apply-credit')
                                                    } else {
                                                        // If no credits to apply, just continue with save
                                                        this.customerConfirm()
                                                    }
                                                } else {
                                                    this.datasets.core.payments_ignored = 1
                                                    this.datasets.core.credits_ignored = 1
                                                    this.customerConfirm()
                                                }
                                            })
                                            .catch(err => {
                                                // An error occurred
                                            })
                                    } else {
                                        this.customerConfirm()
                                    }
                                }, () => {
                                    this.has_error = true
                                })
                        }, () => {
                            this.has_error = true
                        })
                } else {
                    this.customerConfirm()
                }
            },

            customerConfirm() {
                const addressDiffers = this.orderAddressDiffersFromCustomer()
                if (this.customerUpdated == 1 || addressDiffers) {
                    const message = addressDiffers && this.customerUpdated != 1
                        ? 'Order address differs from the customer record. Update the customer address too?'
                        : 'Customer info updated. Would you like to update customer data?'

                    this.$bvModal.msgBoxConfirm(message, {
                        title: 'Save Sales Order',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                        .then(value => {
                            // Yes = save order and customer; No = save order only
                            this.customerUpdated = value ? 1 : 0
                            this.edit()
                        })
                        .catch(err => {
                            // An error occurred
                        })
                } else {
                    this.edit()
                }
            },

            normalizeAddressValue(value) {
                return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase()
            },

            addressMapsEqual(left, right, prefix) {
                const keys = ['address_1', 'address_2', 'city', 'state', 'postal_code', 'country']
                return keys.every((key) => {
                    return this.normalizeAddressValue(left[prefix + key]) === this.normalizeAddressValue(right[prefix + key])
                })
            },

            orderAddressDiffersFromCustomer() {
                if (!this.datasets.core.customerId || !this.customerAddressSnapshot) {
                    return false
                }

                const billingSame = this.addressMapsEqual(
                    this.datasets.core.billingAddress || {},
                    this.customerAddressSnapshot.billing || {},
                    'billing_'
                )
                const shippingSame = this.addressMapsEqual(
                    this.datasets.core.shippingAddress || {},
                    this.customerAddressSnapshot.shipping || {},
                    'shipping_'
                )

                return !(billingSame && shippingSame)
            },

            customerChanged(action) {
                if (this.customerReset == 0) {
                    this.customerUpdated = action
                }
            },

            updateAddress(area, address) {
                this.$nextTick(() => {
                    this.datasets.core[area + 'Address'] = address

                    this.customerChanged(1)
                })
            },

            removeCreditsConfirm()
            {
                this.$bvModal.msgBoxConfirm('Are you sure you want to un-apply all credits on this order?', {
                    title: 'Un-apply Credits',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.removeCredits()
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            removeCredits() {
                let url = 'api/orders/sales-orders/removecredits'
                axios.post(url, {
                    soId: this.datasets.core.id,
                    customerId: this.datasets.core.customerId,
                    rows: this.datasets.rows
                })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Un-apply Credits', 'Un-applied credits successfully!')
                        this.datasets.core.credits_ignored = 0
                        this.datasets.core.payments_ignored = 0
                        this.edit(1)
                    } else {
                        this.showAlertBox('error', 'Error un-applying credits!', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            splitOrderConfirm() {
                this.$bvModal.msgBoxConfirm('Are you sure you want to split this order??', {
                    title: 'Split Order',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.splitOrder()
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            splitOrder() {
                // this.submitting = 1

                let url = 'api/orders/sales-orders/split'
                axios.post(url, {
                    core: this.datasets.core,
                    rows: this.datasets.rows,
                    soNum: this.soNum,
                    updateCustomer: this.customerUpdated
                })
                .then((res) => {
                    // this.submitting = 0

                    if (res.data.status == 'success') {
                        this.datasets.core.deletes = []
                        this.showAlertBox('success', 'Split Order', 'Sales Order split successfully!')
                        this.$router.push({name: 'SalesOrders'})
                    } else {
                        this.showAlertBox('error', 'Error Splitting Sales Order', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            nextRow(idx, col) {
                let target = col + 'input' + (idx + 1)

                if (col == 'sku') {
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
                } else {
                    this.$refs[target][0].$el.focus()
                }
            },

            openModal(modalName, row, extra, extra2) {
                let prefix = 'modal-orders-sales-orders-'
                switch (modalName) {
                    case 'edit-shipping':
                        this.modals[prefix + modalName].active = 1
                        break
                    case 'edit-billing':
                        this.modals[prefix + modalName].active = 1
                        break
                    case 'set-discount':
                        this.modals[prefix + modalName].active = 1
                        break
                    case 'apply-credit':
                        this.modals[prefix + modalName].active = 1
                        this.modals[prefix + modalName].fromSave = this.submitting
                        break
                    case 'receive-payment':
                        this.modals[modalName].active = 1
                        break
                    case 'product-preview':
                        this.modals[modalName].sku = row
                        this.modals[modalName].active = 1
                        break
                    case 'show-customer-card':
                        this.modals[prefix + modalName].active = 1
                        break
                    case 'charge-credit-card':
                        this.modals[modalName].active = 1
                        break
                }

                if (modalName == 'receive-payment') {
                    prefix = 'modal-lists-customers-'
                }

                if (modalName == 'product-preview' || modalName == 'charge-credit-card') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.salesOrders.isBusy = !this.tables.salesOrders.isBusy
            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    // this.datasets.rows.push({sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', percentDiscount: '', available: 0})
                    this.datasets.rows.push({sku: '', description: '', qty: '', qtyShipped: '', rate: '', rateOriginal: '', amount: '', url: '', percentDiscount: '', notes: '', mpn: '', vendor: '', fifo: '', wac: '' })
                    // this.autosuggest.row.suggestions.push([])
                }
            },

            getSalesOrder() {
                let url = 'api/orders/sales-orders/getsalesorder/' + this.soNum
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.datasets.core.appliedCredit = 0
                        this.datasets.core.appliedPayment = 0

                        this.datasets.core.id = res.data.salesOrder.id
                        this.datasets.core.status = res.data.salesOrder.status
                        // this.datasets.core.poNumber = res.data.salesOrder.reference_no
                        this.datasets.core.source = res.data.salesOrder.source
                        this.datasets.core.customerId = res.data.salesOrder.customers_id
                        this.datasets.core.customers_id = res.data.salesOrder.customers_id
                        this.datasets.core.sales_order_number = res.data.salesOrder.sales_order_number
                        this.datasets.core.marketplace_order_number = res.data.salesOrder.marketplace_order_number
                        this.datasets.core.document_order_number = res.data.salesOrder.document_order_number
                            || res.data.salesOrder.display_order_number
                        this.datasets.core.salesRepId = res.data.salesOrder.sales_reps_id
                        this.datasets.core.shippingMethod = res.data.salesOrder.shipping_method
                        this.datasets.core.paymentTerm = res.data.salesOrder.payment_method
                        this.datasets.core.shippingAmount = res.data.salesOrder.shipping_total
                        this.datasets.core.shippingNotes = res.data.salesOrder.shipping_notes
                        this.datasets.core.creditAmount = res.data.salesOrder.credit_total
                        this.datasets.core.paymentAmount = res.data.salesOrder.payment_total
                        this.datasets.core.creditNotes = res.data.salesOrder.credit_notes
                        this.datasets.core.customerNotes = res.data.salesOrder.customer_note
                        this.datasets.core.date = res.data.salesOrder.date
                        this.datasets.core.dateShipped = res.data.salesOrder.date_shipped
                        this.datasets.core.dateConfirmed = res.data.salesOrder.date_confirmed
                        this.datasets.core.location = res.data.salesOrder.location
                        this.datasets.core.cogs = res.data.salesOrder.cogs
                        this.datasets.core.credits_ignored = res.data.salesOrder.credits_ignored
                        this.datasets.core.payments_ignored = res.data.salesOrder.payments_ignored
                        this.datasets.core.discountsOrder = res.data.salesOrder.discount_order !== null ? res.data.salesOrder.discount_order : 0
                        this.datasets.core.company_branding_id = res.data.salesOrder.company_branding_id

                        if (!res.data.salesOrder.internal_note) {
                            let notes = ''
                            if (res.data.salesOrder.customer_note) {
                                notes += 'Order Notes: ' + res.data.salesOrder.customer_note + '\r\n\r\n'
                            }

                            if (res.data.salesOrder.customer.notes) {
                                notes += 'Customer Notes: ' + res.data.salesOrder.customer.notes + '\r\n\r\n' + 'Additional Notes: '
                            }

                            this.datasets.core.internalNote = notes
                        } else {
                            this.datasets.core.internalNote = res.data.salesOrder.internal_note
                        }

                        // Always show order-level addresses. Customer master is only a snapshot for save compare.
                        if (res.data.salesOrder.customer && res.data.salesOrder.customer.name != 'META ERP') {
                            this.datasets.core.customer = res.data.salesOrder.customer.name
                            this.datasets.core.email = res.data.salesOrder.email || res.data.salesOrder.customer.email
                            this.datasets.core.phone = res.data.salesOrder.phone || res.data.salesOrder.customer.phone
                            this.datasets.core.fax = res.data.salesOrder.fax || res.data.salesOrder.customer.fax
                            this.datasets.core.buyer = res.data.salesOrder.buyer || res.data.salesOrder.customer.buyers_name
                            this.customerAddressSnapshot = {
                                billing: {
                                    billing_address_1: res.data.salesOrder.customer.billing_address_1,
                                    billing_address_2: res.data.salesOrder.customer.billing_address_2,
                                    billing_city: res.data.salesOrder.customer.billing_city,
                                    billing_state: res.data.salesOrder.customer.billing_state,
                                    billing_postal_code: res.data.salesOrder.customer.billing_postal_code,
                                    billing_country: res.data.salesOrder.customer.billing_country
                                },
                                shipping: {
                                    shipping_address_1: res.data.salesOrder.customer.shipping_address_1,
                                    shipping_address_2: res.data.salesOrder.customer.shipping_address_2,
                                    shipping_city: res.data.salesOrder.customer.shipping_city,
                                    shipping_state: res.data.salesOrder.customer.shipping_state,
                                    shipping_postal_code: res.data.salesOrder.customer.shipping_postal_code,
                                    shipping_country: res.data.salesOrder.customer.shipping_country
                                }
                            }
                        } else {
                            this.datasets.core.email = res.data.salesOrder.email
                            this.datasets.core.phone = res.data.salesOrder.phone
                            this.datasets.core.fax = res.data.salesOrder.fax
                            this.datasets.core.buyer = res.data.salesOrder.buyer
                            this.customerAddressSnapshot = null
                        }

                        this.datasets.core.billingAddress.billing_address_1 = res.data.salesOrder.billing_address_1
                        this.datasets.core.billingAddress.billing_address_2 = res.data.salesOrder.billing_address_2
                        this.datasets.core.billingAddress.billing_city = res.data.salesOrder.billing_city
                        this.datasets.core.billingAddress.billing_state = res.data.salesOrder.billing_state
                        this.datasets.core.billingAddress.billing_postal_code = res.data.salesOrder.billing_postal_code
                        this.datasets.core.billingAddress.billing_country = res.data.salesOrder.billing_country
                        this.datasets.core.shippingAddress.shipping_address_1 = res.data.salesOrder.shipping_address_1
                        this.datasets.core.shippingAddress.shipping_address_2 = res.data.salesOrder.shipping_address_2
                        this.datasets.core.shippingAddress.shipping_city = res.data.salesOrder.shipping_city
                        this.datasets.core.shippingAddress.shipping_state = res.data.salesOrder.shipping_state
                        this.datasets.core.shippingAddress.shipping_postal_code = res.data.salesOrder.shipping_postal_code
                        this.datasets.core.shippingAddress.shipping_country = res.data.salesOrder.shipping_country
                        this.customerUpdated = 0

                        this.datasets.core.emailSend = res.data.salesOrder.send_copy
                        this.datasets.core.tags = res.data.tags
                        this.datasets.rows = res.data.rows

                        this.datasets.coreCopy = JSON.parse(JSON.stringify(this.datasets.core))

                        this.salesRepGuardCheck()

                        this.constructAddressBlock('billing', this.datasets.core.billingAddress)
                        this.constructAddressBlock('shipping', this.datasets.core.shippingAddress)

                        this.$nextTick(() => {
                            this.datasets.rows.forEach((row, idx, array) => {
                                this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = row.sku
                                this.$refs['skuinput' + idx][0].query = row.sku

                                if (this.datasets.core.status == 'Closed' || this.datasets.core.status == 'Dispatched') {
                                    this.datasets.rows[idx].qohOriginal = +row.qoh + +row.qtyShipped
                                }

                                this.calculateRow(idx)
                            })

                            // this.calculateTotals()
                        })
                        this.calculateTotals()
                    } else {
                        this.$router.push({name: 'SalesOrders' })
                    }
                }, () => {
                    this.has_error = true
                    this.$router.push({name: 'SalesOrders' })
                })
            },

            getPaymentTerms() {
                fetchActivePaymentTerms().then((terms) => {
                    this.datasets.paymentTerms = terms
                })
            },

            getShippingMethods() {
                fetchActiveShippingMethods().then((methods) => {
                    this.datasets.shippingMethods = methods
                })
            },

            getSalesReps() {
                let url = 'api/lists/sales-reps/getsalesreps'
                axios.get(url, {})
                .then((res) => {
                    this.datasets.salesReps = res.data.salesReps
                }, () => {
                    this.has_error = true
                })
            },

            getSalesRepNameById(id) {
                let index = this.datasets.salesReps.findIndex(function(x) {
                    return x.value == id
                })

                if (index > -1) {
                    return this.datasets.salesReps[index].text
                }
            },

            getOrderTags() {
                let url = 'api/orders/sales-orders/getordertags'
                axios.get(url, {})
                .then((res) => {
                    this.tags.list = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },

            deleteRow(index) {
                let previousSkus = []
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku && idx != index) {
                        previousSkus.push(row.sku)
                    }
                })

                let target = 'skuinput' + (index + 1)

                if (this.datasets.rows.length == 1 && index == 0) {
                    this.datasets.core.deletes.push(this.datasets.rows[index].sku)

                    this.datasets.rows[0].sku = ''
                    this.datasets.rows[0].description = ''
                    this.datasets.rows[0].qty = ''
                    this.datasets.rows[0].qtyShipped = ''
                    this.datasets.rows[0].rate = ''
                    this.datasets.rows[0].rateOriginal = ''
                    this.datasets.rows[0].amount = ''
                    this.datasets.rows[0].url = ''
                    this.datasets.rows[0].percentDiscount = ''
                    this.datasets.rows[0].mpn = ''
                    this.datasets.rows[0].vendor = ''
                    this.datasets.rows[0].fifo = ''
                    this.datasets.rows[0].wac = ''
                } else {
                    this.datasets.core.deletes.push(this.datasets.rows[index].sku)
                    this.datasets.rows.splice(index, 1)
                }

                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku) {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = previousSkus[idx]
                        this.$refs['skuinput' + idx][0].query = row.sku
                    } else {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = ''
                        this.$refs['skuinput' + idx][0].query = ''
                    }
                })

                this.calculateTotals()
            },

            copyDownDiscount(val) {
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku) {
                        row.percentDiscount = val

                        this.calculateRow(idx)
                    }
                })

                this.calculateTotals()
            },

            setPaymentCredit(payment, credit) {
                this.datasets.core.appliedPayment = payment
                this.datasets.core.appliedCredit = credit

                this.customerConfirm()
            },

            qtyOrderedHasPositive() {
                let result = false
                let status = this.datasets.core.status
                if (status == 'Dispatched' || status == 'Closed') {
                    this.datasets.rows.forEach((row, idx, array) => {
                        if (row.qtyShipped > 0) {
                            result = true
                        }
                    })
                }

                this.useQtyShipped = result

                return result
            },

            calculateAllRows() {
                this.datasets.rows.forEach((row, idx) => {
                    this.calculateRow(idx)
                })
            },

            calculateRow(index) {
                let qty = this.datasets.rows[index].qty > 0 ? this.datasets.rows[index].qty : 0
                let qtyShippedRaw = this.datasets.rows[index].qtyShipped
                let qtyShipped = qtyShippedRaw > 0 ? qtyShippedRaw : 0
                let activeQty
                if (this.datasets.core.status == 'Closed') {
                    // Closed always uses qtyShipped
                    activeQty = qtyShipped
                } else if (this.datasets.core.status == 'Dispatched') {
                    // Dispatched: If ANY row has qtyShipped > 0, use qtyShipped for ALL rows, otherwise use qty ordered
                    if (this.qtyOrderedHasPositive()) {
                        activeQty = qtyShipped
                    } else {
                        activeQty = qty
                    }
                } else {
                    // Other statuses use qty ordered
                    activeQty = qty
                }
                let rate = this.datasets.rows[index].rate ? this.datasets.rows[index].rate : 0
                let discount = this.datasets.rows[index].percentDiscount !== '' && this.datasets.rows[index].percentDiscount !== null ? Number(this.datasets.rows[index].percentDiscount) : 0
                let amount = 0

                if (rate > 0 && discount > 0) {
                    let discounted = Number(rate) - (rate * (discount * .01))
                    this.datasets.rows[index].rateDiscounted = discounted.toFixed(2)

                    amount = Number(activeQty) * this.datasets.rows[index].rateDiscounted
                } else {
                    amount = Number(activeQty) * this.datasets.rows[index].rate
                    this.datasets.rows[index].rateDiscounted = 0
                }

                this.datasets.rows[index].amount = this.formatCurrency(amount)

                this.calculateTotals()
            },

            calculateTotals() {
                let subtotal = Number(0)
                let discounts = Number(0)
                // Check if ANY row has qtyShipped > 0 for Dispatched status
                let useQtyShippedForDispatched = this.datasets.core.status == 'Dispatched' ? this.qtyOrderedHasPositive() : false
                
                this.datasets.rows.forEach((row, idx, array) => {
                    let activeQty
                    if (this.datasets.core.status == 'Closed') {
                        // Closed always uses qtyShipped
                        activeQty = row.qtyShipped
                    } else if (this.datasets.core.status == 'Dispatched') {
                        // Dispatched: If ANY row has qtyShipped > 0, use qtyShipped for ALL rows, otherwise use qty ordered
                        activeQty = useQtyShippedForDispatched ? row.qtyShipped : row.qty
                    } else {
                        // Other statuses use qty ordered
                        activeQty = row.qty
                    }
                    subtotal += row.rate * activeQty

                    let discount = row.percentDiscount !== '' && row.percentDiscount !== null ? Number(row.percentDiscount) : 0
                    if (discount > 0) {
                        discounts += (row.rate * activeQty) - (row.rateDiscounted * activeQty)
                    }
                })
                this.datasets.core.subtotal = this.formatCurrency(subtotal)
                this.datasets.core.discounts = this.formatCurrency(discounts)
                this.datasets.core.total = this.formatCurrency(subtotal - discounts + +this.datasets.core.shippingAmount)
            },

            focusMeRow(index) {
                // this.autosuggest.row.currentIndex = index

                if (this.datasets.rows.length == index + 1) {
                    this.datasets.rows.push({sku: '', description: '', qty: '', qtyShipped: '', rate: '', rateOriginal: '', amount: '', url: '', percentDiscount: '', notes: '', mpn: '', vendor: '', fifo: '', wac: ''})
                    // this.autosuggest.row.suggestions.push([])

                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }
            },

            clickHandlerCustomer(item) {
                let query = this.datasets.core.customer
                if (!query) {
                    this.autosuggest.customer.suggestions = []
                }
            },

            fetchResultsCustomer() {
                const query = this.datasets.core.customer

                clearTimeout(this.autosuggest.customer.timeout);
                this.autosuggest.customer.timeout = setTimeout(() => {
                    const customersPromise = axios.get('api/lists/customers/getcustomersfilter/' + query);

                    Promise.all([customersPromise]).then(values => {
                        this.autosuggest.customer.suggestions = []

                        const customers = values[0].data.items

                        customers.length &&
                        this.autosuggest.customer.suggestions.push({ name: "customers", data: customers })
                    })
                }, this.autosuggest.customer.debounceMilliseconds)
            },

            fetchResultsRow() {
                const query = this.datasets.rows[this.autosuggest.row.currentIndex].sku

                clearTimeout(this.autosuggest.row.timeout);
                this.autosuggest.row.timeout = setTimeout(() => {
                    const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query);

                    Promise.all([productsPromise]).then(values => {
                        this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex] = []

                        const products = values[0].data.items

                        products.length &&
                        this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex].push({ name: "products", data: products })
                    })
                }, this.autosuggest.row.debounceMilliseconds)
            },

            onSelectedCustomer(item) {
                if (item) {
                    this.customerReset = 1

                    this.datasets.core.customer = item.item.name
                    this.datasets.core.customerId = item.item.id
                    this.datasets.core.salesRepId = item.item.sales_rep_id
                    this.datasets.core.email = item.item.email
                    this.datasets.core.phone = item.item.phone
                    this.datasets.core.fax = item.item.fax
                    this.datasets.core.billingAddress = item.item.billing
                    this.datasets.core.shippingAddress = item.item.shipping
                    this.customerAddressSnapshot = {
                        billing: Object.assign({}, item.item.billing || {}),
                        shipping: Object.assign({}, item.item.shipping || {})
                    }
                    this.datasets.core.shippingMethod = item.item.shipping_method
                    this.datasets.core.paymentTerm = item.item.payment_method
                    this.datasets.core.buyer = item.item.buyer

                    this.customerReset = 0
                    this.pageKey++
                }
            },

            onSelectedRow(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed, available, mpn, lastCost, qoo, vendor) {
                this.addToDeletes(this.datasets.rows[idx].sku)

                this.datasets.rows[idx].sku = sku
                this.datasets.rows[idx].description = description
                this.datasets.rows[idx].rate = rate
                this.datasets.rows[idx].rateOriginal = rate
                this.datasets.rows[idx].url = url
                this.datasets.rows[idx].qoh = qoh
                this.datasets.rows[idx].cost = cost
                this.datasets.rows[idx].available = available
                this.datasets.rows[idx].lastCost = lastCost
                this.datasets.rows[idx].mpn = mpn
                this.datasets.rows[idx].vendor = vendor

                this.calculateRow(idx)
            },

            onKeyTabCustomer(evt) {
                let query = this.datasets.core.customer.toLowerCase()

                setTimeout(() => {
                    if (this.autosuggest.customer.suggestions.length) {
                        let results = this.autosuggest.customer.suggestions[0].data

                        let resultName = results[0].name

                        if (resultName == query) {
                            this.customerReset = 1

                            this.datasets.core.customer = results[0].name
                            this.datasets.core.customerId = results[0].id
                            this.datasets.core.salesRepId = results[0].sales_rep_id
                            this.datasets.core.email = results[0].email
                            this.datasets.core.phone = results[0].phone
                            this.datasets.core.fax = results[0].fax
                            this.datasets.core.billingAddress = results[0].billing
                            this.datasets.core.shippingAddress = results[0].shipping
                            this.customerAddressSnapshot = {
                                billing: Object.assign({}, results[0].billing || {}),
                                shipping: Object.assign({}, results[0].shipping || {})
                            }
                            this.autosuggest.customer.suggestions = []

                            this.customerReset = 0
                        } else {
                            this.autosuggest.customer.suggestions = []
                        }
                    }
                }, 1500)
            },

            getSuggestionValueCustomer(suggestion) {
                return suggestion.item.name
            },

            getSuggestionValueRow(suggestion) {
                return suggestion.item.name
            },

            suggestFirstCustomer(query) {
                let suggests = this.autosuggest.customer.suggestions
                let arr = suggests[0].data

                if (arr.length) {
                    for (var i = 0; i < arr.length; i++) {
                        let cur = arr[i].name.toLowerCase()
                        if (cur.includes(query.toLowerCase())) {
                            this.customerReset = 1

                            this.datasets.core.customer = arr[i].name
                            this.datasets.core.customerId = arr[i].id
                            this.datasets.core.email = arr[i].email
                            this.datasets.core.salesRepId = arr[i].sales_rep_id
                            this.datasets.core.phone = arr[i].phone
                            this.datasets.core.fax = arr[i].fax
                            this.datasets.core.billingAddress = arr[i].billing
                            this.datasets.core.shippingAddress = arr[i].shipping
                            this.customerAddressSnapshot = {
                                billing: Object.assign({}, arr[i].billing || {}),
                                shipping: Object.assign({}, arr[i].shipping || {})
                            }
                            this.autosuggest.customer.suggestions = []

                             this.customerReset = 0

                            break;
                        } else {
                            continue
                        }
                    }
                }
            },

            suggestFirstRow(idx, sku, description, rate, url, qoh, cost, available, mpn, lastCost, qoo, vendor) {
                this.addToDeletes(this.datasets.rows[idx].sku)

                this.datasets.rows[idx].sku = sku
                this.datasets.rows[idx].description = description
                this.datasets.rows[idx].rate = rate
                this.datasets.rows[idx].rateOriginal = rate
                this.datasets.rows[idx].url = url
                this.datasets.rows[idx].qoh = qoh
                this.datasets.rows[idx].cost = cost
                this.datasets.rows[idx].available = available
                this.datasets.rows[idx].lastCost = lastCost
                this.datasets.rows[idx].mpn = mpn
                this.datasets.rows[idx].vendor = vendor

                this.calculateRow(idx)
            },

            edit(silent) {
                if (this.approveRowQty()) {
                    this.submitting = true

                    let url = 'api/orders/sales-orders/edit'
                    axios.post(url, {
                        core: this.datasets.core,
                        rows: this.datasets.rows,
                        updateCustomer: this.customerUpdated
                    })
                    .then((res) => {
                        this.submitting = false

                        if (res.data.status == 'success') {
                            this.datasets.core.deletes = []
                            this.getSalesOrder()
                            if (!silent) {
                                this.showAlertBox('success', 'Sales Order Save', 'Sales Order Saved successfully!')
                            }
                        } else {
                            if (!silent) {
                                this.showAlertBox('error', 'Error Saving Sales Order', res.data.status)
                            }
                        }
                    }, () => {
                        this.has_error = true
                    })
                } else {
                    this.showAlertBox('error', 'QOH Overage', 'Please fix red highlighted rows!')
                }
            },

            constructAddressBlock(area, val) {
                if (area == 'billing') {
                    let billing
                    if (val.billing_address_1) { billing = val.billing_address_1; }
                    if (val.billing_address_2) { billing += "\r\n" + val.billing_address_2; }
                    if (val.billing_city) { billing += "\r\n" + val.billing_city; }
                    if (val.billing_state) { billing += ', ' + val.billing_state; }
                    if (val.billing_postal_code) { billing += ' ' + val.billing_postal_code; }
                    if (val.billing_country) { billing += "\r\n" + val.billing_country; }

                    this.datasets.core.billingAddressBlock = billing
                } else {
                    let shipping
                    if (val.shipping_address_1) { shipping = val.shipping_address_1; }
                    if (val.shipping_address_2) { shipping += "\r\n" + val.shipping_address_2; }
                    if (val.shipping_city) { shipping += "\r\n" + val.shipping_city; }
                    if (val.shipping_state) { shipping += ', ' + val.shipping_state; }
                    if (val.shipping_postal_code) { shipping += ' ' + val.shipping_postal_code; }
                    if (val.shipping_country) { shipping += "\r\n" + val.shipping_country; }

                    this.datasets.core.shippingAddressBlock = shipping
                }
            },

            resetView() {
                this.datasets.rows = []

                for (var index = 0; index <= 2; index++) {
                    this.datasets.rows.push({sku: '', description: '', qty: '', qtyShipped: '', rate: '', rateOriginal: '', amount: '', url: '', percentDiscount: '', available: 0, notes: '', mpn: '', vendor: '', fifo: '', wac: ''})
                    this.autosuggest.row.suggestions.push([])
                }

                this.currentIndex = ''
            },

            calculateCogs() {
                this.datasets.core.cogs = Number(0)
                let cogs = Number(0)
                // Check if ANY row has qtyShipped > 0 for Dispatched status
                let useQtyShippedForDispatched = this.datasets.core.status == 'Dispatched' ? this.qtyOrderedHasPositive() : false
                
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku) {
                        // let itemType = row.product_type
                        let status = this.datasets.core.status
                        // let wac = itemType == 'Bundle' ? row.cost : row.wac
                        let wac = row.wac
                        let qty
                        if (status == 'Closed') {
                            // Closed always uses qtyShipped
                            qty = row.qtyShipped
                        } else if (status == 'Dispatched') {
                            // Dispatched: If ANY row has qtyShipped > 0, use qtyShipped for ALL rows, otherwise use qty ordered
                            qty = useQtyShippedForDispatched ? row.qtyShipped : row.qty
                        } else {
                            // Other statuses use qty ordered
                            qty = row.qty
                        }

                        if (wac && qty) {
                            cogs += +wac * +qty
                        }
                    }
                })

                this.datasets.core.cogs = this.formatCurrency(cogs)
            },

            sanitizeNumeric(val) {
                if (val === '' || val === null || val === undefined) {
                    return val
                }

                val = String(val)

                // Strip everything except digits, dot, and minus
                let sanitized = val.replace(/[^0-9.\-]/g, '')

                // Normalize minus: allow at most one, and force it to the front
                const hasMinus = sanitized.indexOf('-') !== -1
                sanitized = sanitized.replace(/-/g, '')
                if (hasMinus) {
                    sanitized = '-' + sanitized
                }

                // Prevent more than one decimal point
                const parts = sanitized.split('.')
                if (parts.length > 2) {
                    sanitized = parts[0] + '.' + parts.slice(1).join('')
                }

                return sanitized
            },

            preventNonNumeric(event) {
                if (this.isPriceMathField && this.isPriceMathField(event)) {
                    return this.allowPriceMathKeydown(event)
                }

                const allowed = [
                    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                    'Home', 'End', '.'
                ]

                // Always allow navigation / control keys
                if (allowed.includes(event.key)) return
                if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x', 'z'].includes(event.key.toLowerCase())) return

                // Allow one leading minus for negative numbers
                if (event.key === '-') {
                    const input = event.target
                    const value = input.value || ''
                    const start = input.selectionStart
                    const end = input.selectionEnd

                    // Simulate the value after this keypress
                    const next = value.slice(0, start) + '-' + value.slice(end)

                    // Valid if minus will end up at position 0 and there is only one minus
                    const firstMinus = next.indexOf('-')
                    const lastMinus = next.lastIndexOf('-')
                    if (firstMinus === 0 && firstMinus === lastMinus) {
                        return
                    }

                    event.preventDefault()
                    return
                }

                // Allow digits
                if (event.key >= '0' && event.key <= '9') return

                // Block everything else
                event.preventDefault()
            },

            onNumericInput(val, index, field) {
                const sanitized = this.sanitizeNumeric(val)
                this.datasets.rows[index][field] = sanitized

                // Safety net for paste: if stripping occurred, update both b-form-input's
                // internal localValue and the DOM so they stay in sync with the model.
                if (sanitized !== String(val)) {
                    const refMap = {
                        qty: 'qtyinput',
                        qtyShipped: 'qtyShippedinput',
                        rate: 'rateinput',
                        percentDiscount: 'percentinput'
                    }
                    const ref = this.$refs[refMap[field] + index]
                    if (ref) {
                        const el = Array.isArray(ref) ? ref[0] : ref
                        if (el.localValue !== undefined) {
                            el.localValue = sanitized
                        }
                        const inputEl = el.$el || el
                        inputEl.value = sanitized
                    }
                }
            },

            approveRowQty() {
                if ((this.datasets.core.status == 'Closed' || this.datasets.core.status == 'Dispatched') && this.env.COMPANY_APP_QOHOVERAGE) {
                    let pass = true
                    this.datasets.rows.forEach((row, idx, array) => {
                        if (row.qtyShipped > (+row.qohOriginal + +10)) {
                            pass = false
                        }
                    })

                    return pass
                } else {
                    return true
                }
            },

            salesRepGuardCheck() {
                let salesRep = this.getSalesRepNameById(this.datasets.core.salesRepId)
                let authName = store.state.auth.user.name

                if (!this.$can('view-all')) {
                    if (this.$can('view-sales-order-self')) {
                        if (salesRep) {
                            if (salesRep != authName) {
                                this.$router.back()
                            }
                        }
                    }
                }
            },

            populateQtyShipped() {
                this.$bvModal.msgBoxConfirm('Are you sure you want to populate Qty Shipped with Qty Ordered values?', {
                    title: 'Populate Qty Shipped',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.datasets.rows.forEach((row, index) => {
                            row.qtyShipped = row.qty;
                            this.calculateRow(index);
                        });
                        this.calculateTotals();
                        this.showAlertBox('success', 'Qty Shipped Populated', 'Qty Shipped has been populated with Qty Ordered values.');
                    }
                })
                .catch(err => {
                    // An error occurred
                });
            },

            setCredit(credit) {
                this.datasets.core.appliedCredit = credit
                this.datasets.core.creditAmount = credit
                
                // If this was triggered from the Save button, continue with save process
                if (this.submitting) {
                    this.customerConfirm()
                } else {
                    // If triggered directly, save the credit to the database
                    this.saveCreditToDatabase(credit)
                }
            },

            saveCreditToDatabase(credit) {
                let url = 'api/orders/sales-orders/applycredit'
                axios.post(url, {
                    soId: this.datasets.core.id,
                    customerId: this.datasets.core.customerId,
                    creditAmount: credit,
                    rows: this.datasets.rows
                })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Credit Applied', 'Credit applied to order successfully!')
                        // Refresh the sales order data to reflect the changes
                        this.getSalesOrder()
                    } else {
                        this.showAlertBox('error', 'Error Applying Credit', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },

            setDiscount(discount) {
                this.datasets.core.discountsOrder = discount !== null && discount !== undefined ? Number(discount) : 0
                this.datasets.rows.forEach((row, idx) => {
                    if (row.sku) {
                        row.percentDiscount = discount !== null && discount !== undefined ? Number(discount) : 0
                        this.calculateRow(idx)
                    }
                })
                this.calculateTotals()
            },

            onPaymentProcessed(paymentData) {
                // Refresh the sales order data to reflect the new payment
                this.getSalesOrder()
            },

            closePaymentResult() {
                this.$bvModal.hide('payment-result-modal')
            },

            onShowPaymentResult(paymentResult) {
                this.paymentResult = paymentResult
                this.$bvModal.show('payment-result-modal')
            },

            getCompanyBrandings() {
                let url = 'api/orders/sales-orders/company-branding/active'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.datasets.companyBrandings = res.data.brandings
                    }
                }, () => {
                    this.has_error = true
                })
            },
            formatCurrency(value) {
                const numValue = parseFloat(value)
                if (isNaN(numValue)) return '0.00'
                
                // Convert to string first to check decimal places accurately
                let valueStr = String(value)
                // Remove any trailing zeros and decimal point from original string
                valueStr = valueStr.replace(/0+$/, '').replace(/\.$/, '')
                
                // Check if string representation has more than 2 decimal places
                let hasMoreDecimals = false
                if (valueStr.indexOf('.') !== -1) {
                    const parts = valueStr.split('.')
                    const decimalPlaces = parts[1] ? parts[1].length : 0
                    hasMoreDecimals = decimalPlaces > 2
                }
                
                // If the value has more than 2 decimal places, show up to 4 decimal places
                if (hasMoreDecimals) {
                    // Remove trailing zeros but keep up to 4 decimal places
                    let formatted = numValue.toFixed(4)
                    // Remove trailing zeros and decimal point if it becomes the last character
                    formatted = formatted.replace(/0+$/, '').replace(/\.$/, '')
                    return formatted
                }
                
                // For normal values, show 2 decimal places
                return numValue.toFixed(2)
            }
        },

    	computed: {
            displayOrderNumber() {
                const document = this.datasets.core.document_order_number
                if (document !== null && document !== undefined && String(document).trim() !== '') {
                    return String(document).trim()
                }
                const marketplace = this.datasets.core.marketplace_order_number
                if (marketplace !== null && marketplace !== undefined && String(marketplace).trim() !== '') {
                    return String(marketplace).trim()
                }
                return this.datasets.core.sales_order_number || this.soNum
            },
			filteredTags() {
                return this.tags.list.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tags.currentTag.toLowerCase()) !== -1;
                })
            },
            companyBrandingOptions() {
                const options = [
                    { value: null, text: 'Use Default Settings' }
                ];
                
                this.datasets.companyBrandings.forEach(branding => {
                    options.push({
                        value: branding.id,
                        text: branding.name
                    });
                });
                
                return options;
            }
		},

        watch: {
            'useQtyShipped': {
                handler() {
                    this.calculateAllRows()
                }
            },

            'datasets.core.shippingAddress': {
				handler(val) {
                    if (val) {
                        this.constructAddressBlock('shipping', val)
                    }
				},
                deep: true
            },

            'datasets.core.billingAddress': {
                handler(val) {
                    if (val) {
                        this.constructAddressBlock('billing', val)
                    }
				},
                deep: true
            },

            'datasets.core.status': {
                handler(val) {
                    this.calculateAllRows()
                    this.calculateTotals()
				},
                deep: true
            },

            'datasets.rows': {
                handler(val) {
                    this.calculateCogs()
                },
                deep: true
            }
        },

        mounted() {
            this.getSalesReps()
            this.getPaymentTerms()
            this.getShippingMethods()
            this.getOrderTags()
            this.getCompanyBrandings()
            this.getSalesOrder()
            this.calculateCogs()
            this.datasets.locations = Object.keys(this.getLocations)

            // pusher
            Echo.channel('order-details-updated')
                .listen('OrderDetailsUpdated', (e) => {
                    let matched = false
                    e.applieds.forEach(soNum => {
                        if (this.soNum == soNum) {
                            matched = true
                        }
                    })

                    if (matched) {
                        this.getSalesOrder()
                    }
                })

            // this.resetView()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-orders-sales-orders-edit-shipping':
                        this.modals[modalId].active = 0

                        break
                    case 'modal-orders-sales-orders-edit-billing':
                        this.modals[modalId].active = 0

                        break
                    case 'modal-orders-sales-orders-set-discount':
                        this.modals[modalId].active = 0

                        break
                    case 'modal-orders-sales-orders-apply-credit':
                        this.modals[modalId].active = 0
                        // Reset submitting flag if modal was closed without applying credits
                        // (if credits were applied, setCredit already handled the save flow)
                        this.submitting = false
                        this.modals[modalId].fromSave = false

                        break
                    case 'modal-orders-sales-orders-show-customer-card':
                        this.modals[modalId].active = 0

                        break
                    case 'modal-lists-customers-receive-payment':
                        this.modals['recieve-payment'].active = 0
                        break
                    case 'modal-common-product-preview':
                        this.modals['product-preview'].active = 0
                        break
                    case 'modal-common-charge-credit-card':
                        this.modals['charge-credit-card'].active = 0
                        break
                }
            })
	    }
  }
</script>
<style lang="scss">
    #sales-order-edit {
        .highlight-red {
            background: red;
        }

        .table-totals-col {
            width: 20%;
        }

        .products-thumbs {
            max-width: 75px;
            max-height: 75px;
        }

        .th-number {
            width: 40px;
        }

        .vue-tags-input {
            max-width: 100%;

            .ti-input {
                display: block;
                width: auto;
                height: calc(1.2em + 0.75rem + 2px);
                // padding: 0.375rem 0.75rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #495057;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                // justify-content: center;
                width: 100%;

                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }

            #autosuggest { width: 100%; display: block; }

            .autosuggest__results {
                position: relative;
            }

            .autosuggest__results-container {
                width: 300px;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }

            #autosuggest-autosuggest__results {
                overflow-y: hidden;
                // max-height: 200px;
            }
        }

        .fa-fill-drip {
            font-size: 0.8rem;
        }
    }
</style>
